/**
 * Module-level analytics capture for use outside the React provider tree.
 *
 * Call setBackends() during app init (before any components mount) so that
 * capture() works from providers that mount before ObservabilityProvider
 * (e.g. MeshProvider, App.tsx lifecycle events).
 *
 * Components inside the ObservabilityProvider tree should prefer the
 * useAnalytics() hook, but capture() works everywhere.
 */
let _analytics;
let _errors;
export function setBackends(analytics, errorMonitoring) {
    _analytics = analytics;
    _errors = errorMonitoring;
}
export function getAnalyticsBackend() {
    return _analytics;
}
export function getErrorBackend() {
    return _errors;
}
export function capture(event, properties) {
    _analytics?.capture(event, properties);
}
export function identify(userId, properties) {
    _analytics?.identify(userId, properties);
}
export function captureException(error, context) {
    _errors?.captureException(error, context);
}
export function captureMessage(message, level, context) {
    _errors?.captureMessage?.(message, level, context);
}
export function addBreadcrumb(category, message, data) {
    _errors?.addBreadcrumb?.(category, message, data);
}
